import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { UsersReducerActionType } from '../reducers/usersReducer';
import {
  ApiUsersResponseType,
  ApiUserType,
  UserDataToEditType,
} from '../features/Users/types';
import { CUSTOMERS_PER_PAGE } from '../features/Users/UserList';
import { UpdateEmailNotification } from 'src/features/Users/Details/Settings/types';

export const LIST_USERS = 'list_users';
export const ADD_USER = 'add_user';
export const DELETE_USER = 'delete_user';
export const GET_USER = 'get_user';
export const USER_DETAIL_UPDATE_EMAIL_NOTIFICATION =
  'user_detail_update_email_notification';
export const USER_DETAIL_UPDATE_NEWSLETTER_NOTIFICATION =
  'user_detail_update_newsletter_notification';

export const listUsers =
  (page: number, text: string, roles: string[] = []) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { get },
    } = getState();

    const rolesQuery = roles
      .map(role => `&roles[]=${encodeURIComponent(role)}`)
      .join('');

    get(
      `/back-office/profile/search?query=${encodeURIComponent(
        text
      )}&types[]=user&per_page=${CUSTOMERS_PER_PAGE}&page=${page}${rolesQuery}`,
      (response: ApiUsersResponseType): void => {
        response.data &&
          dispatch({
            type: LIST_USERS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const addUser =
  (
    body: any,
    successCallback: (userId: string) => void,
    failureCallback: () => void
  ) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { post, get },
    } = getState();

    post(
      '/users',
      body,
      (userId: string) => {
        successCallback(userId);
        get(`/users/${userId}`, (response: any) => {
          dispatch({
            type: ADD_USER,
            payload: response.data,
          });
        });
      },
      () => failureCallback()
    );
  };

export const deleteUser =
  (userId: string, successCallback: () => void, failureCallback: () => void) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/users/${userId}`,
      {},
      () => {
        dispatch({ type: DELETE_USER, payload: userId });
        successCallback();
      },
      () => failureCallback()
    );

    return Promise.resolve();
  };

export const getUser =
  (id: string) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { get },
      users: { items },
    } = getState();

    const user = items.find((user: ApiUserType) => id === user.id);

    if (user) {
      dispatch({
        type: GET_USER,
        payload: user,
      });
    } else
      get(`/users/${id}`, (response: any): void => {
        response.data &&
          dispatch({
            type: GET_USER,
            payload: response.data,
          });
      });
  };

export const editUser =
  (
    body: UserDataToEditType,
    successCallback?: () => void,
    failureCallback?: () => void
  ) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { patch },
      users: { userDetail },
    } = getState();

    patch(
      `/users/${userDetail.id}`,
      body,
      () => {
        getUser(userDetail.id)(dispatch, getState);
        successCallback && successCallback();
      },
      () => failureCallback && failureCallback()
    );
  };

export const userDetailUpdateEmailNotification =
  (
    key: UpdateEmailNotification['key'],
    checked: boolean,
    newsLetter: boolean,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (dispatch: Dispatch<UsersReducerActionType>, getState: () => RootState) => {
    const {
      client: { put },
    } = getState();

    const payload = { key, checked: checked ? 'true' : 'false' };

    let body: {
      type: string;
      payload: {
        key: UpdateEmailNotification['key'];
        checked: string;
      };
    };

    if (newsLetter) {
      body = {
        type: USER_DETAIL_UPDATE_NEWSLETTER_NOTIFICATION,
        payload,
      };
    } else {
      body = {
        type: USER_DETAIL_UPDATE_EMAIL_NOTIFICATION,
        payload,
      };
    }

    dispatch(body);

    put(
      `/users/settings/${key}`,
      { value: payload.checked },
      successCallback,
      () => {
        failureCallback();

        dispatch({
          ...body,
          payload: {
            ...body.payload,
            checked: !checked ? 'true' : 'false',
          },
        });
      }
    );
  };
